// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-item-content-supplier {
    display: flex;
    justify-content: space-between;
    min-height: 65px;
    align-items: center;
  }
  
  .form-item-supplier-label {
    flex: 0 0 6.5rem;
    font-weight: 500;
    color: var(--color-primary);
    text-align: left;
    margin-right: 0.5rem;
  }
  .error-message {
    position: absolute;
    top: 60%;
    color: red;
    font-size: 10px;
    /* margin-top: 5px; */

  }
  
  
  .form-item-input-supplier {
    width:60%;
    background-color: #D9D9D933;
    overflow: hidden;
    
  }
  .ant-table-container {
    border-radius: 0;
  }
.styled-table .ant-table {
    border-radius: 0 !important;
}
.styled-table .ant-table-content table {
    border-radius: 0;
    border-spacing: 2px;
}
.styled-table .ant-table-thead .ant-table-cell {
    background-color: var(--color-primary);
    color: #ffffff;
    text-align: left;
    border: 1px solid black;
    border-radius: 0;
    border-spacing: 1px;
}
.styled-table .ant-table-container table>thead>tr:first-child >*:first-child {
    border-start-start-radius: 0;
}
.styled-table .ant-table-container table>thead>tr:last-child >*:last-child {
    border-start-end-radius: 0;
}
.styled-table .ant-table-thead .ant-table-cell::before {
    height: 0!important;
  } 
.styled-table .ant-table-tbody .ant-table-row {
    background-color: var(--color-primary);
    color: #ffffff;
    text-align: left;
}
.styled-table .ant-table-cell, .ant-table-row {
    border: 1px solid black;
}
.styled-table .ant-table-tbody .ant-table-cell {
  background-color: #ffffff;
}

.styled-table-container .ant-table-wrapper .ant-table-pagination {
  display: flex;
  flex-wrap: nowrap;
  row-gap: 8px;
}

@media (max-width: 768px) {
    .form-item-supplier-label {
      font-size: 0.875rem; 
      flex: 0 0 2rem; 
    }
  
    .form-item-content-supplier {
      flex-direction: column; 
      align-items: flex-start;
      justify-content: flex-start;
    }
  
    .form-item-input-supplier {
      width: 100%; 
    }
  
  }
  
  @media (max-width: 576px) {
    .form-item-supplier-label {
      font-size: 0.75rem; 
    }
    .form-item-input-supplier {
      width: 100%;
    }
    .form-item-button-supplier {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: auto;

    }
    .form-item-button-supplier button:first-child {
        margin-bottom: 1rem;
        margin-right: 0;

    }
  }

  @media (max-width: 320px) {
    .styled-table-container .ant-table-wrapper .ant-table-pagination {
      display: flex;
      flex-wrap: wrap;
      row-gap: 8px;
    }
  }

  @media (max-width: 576px) {
    .error-message {
      font-size: 10px; 
      margin-top: 2px; 
    }
  }

  .styled-table {
    width: 100%;
    table-layout: fixed; 
    white-space: nowrap; 
    overflow-x: auto; 
  }
  
  .styled-table .ant-table-tbody .ant-table-cell {
    width: auto; 
    max-width: 200px; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .styled-table .ant-table-content {
    min-width: 100%;
    width: auto;
  }

  .styled-table-container .ant-table-wrapper .ant-table-pagination {
    justify-content:  center;
    margin-top: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Admin/Supplier.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,qBAAqB;;EAEvB;;;EAGA;IACE,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;;EAElB;EACA;IACE,gBAAgB;EAClB;AACF;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mBAAmB;EACrB;AACF;IACI,sCAAsC;IACtC,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;IACI;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,2BAA2B;IAC7B;;IAEA;MACE,WAAW;IACb;;EAEF;;EAEA;IACE;MACE,kBAAkB;IACpB;IACA;MACE,WAAW;IACb;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;;IAEhB;IACA;QACI,mBAAmB;QACnB,eAAe;;IAEnB;EACF;;EAEA;IACE;MACE,aAAa;MACb,eAAe;MACf,YAAY;IACd;EACF;;EAEA;IACE;MACE,eAAe;MACf,eAAe;IACjB;EACF;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB","sourcesContent":[".form-item-content-supplier {\n    display: flex;\n    justify-content: space-between;\n    min-height: 65px;\n    align-items: center;\n  }\n  \n  .form-item-supplier-label {\n    flex: 0 0 6.5rem;\n    font-weight: 500;\n    color: var(--color-primary);\n    text-align: left;\n    margin-right: 0.5rem;\n  }\n  .error-message {\n    position: absolute;\n    top: 60%;\n    color: red;\n    font-size: 10px;\n    /* margin-top: 5px; */\n\n  }\n  \n  \n  .form-item-input-supplier {\n    width:60%;\n    background-color: #D9D9D933;\n    overflow: hidden;\n    \n  }\n  .ant-table-container {\n    border-radius: 0;\n  }\n.styled-table .ant-table {\n    border-radius: 0 !important;\n}\n.styled-table .ant-table-content table {\n    border-radius: 0;\n    border-spacing: 2px;\n}\n.styled-table .ant-table-thead .ant-table-cell {\n    background-color: var(--color-primary);\n    color: #ffffff;\n    text-align: left;\n    border: 1px solid black;\n    border-radius: 0;\n    border-spacing: 1px;\n}\n.styled-table .ant-table-container table>thead>tr:first-child >*:first-child {\n    border-start-start-radius: 0;\n}\n.styled-table .ant-table-container table>thead>tr:last-child >*:last-child {\n    border-start-end-radius: 0;\n}\n.styled-table .ant-table-thead .ant-table-cell::before {\n    height: 0!important;\n  } \n.styled-table .ant-table-tbody .ant-table-row {\n    background-color: var(--color-primary);\n    color: #ffffff;\n    text-align: left;\n}\n.styled-table .ant-table-cell, .ant-table-row {\n    border: 1px solid black;\n}\n.styled-table .ant-table-tbody .ant-table-cell {\n  background-color: #ffffff;\n}\n\n.styled-table-container .ant-table-wrapper .ant-table-pagination {\n  display: flex;\n  flex-wrap: nowrap;\n  row-gap: 8px;\n}\n\n@media (max-width: 768px) {\n    .form-item-supplier-label {\n      font-size: 0.875rem; \n      flex: 0 0 2rem; \n    }\n  \n    .form-item-content-supplier {\n      flex-direction: column; \n      align-items: flex-start;\n      justify-content: flex-start;\n    }\n  \n    .form-item-input-supplier {\n      width: 100%; \n    }\n  \n  }\n  \n  @media (max-width: 576px) {\n    .form-item-supplier-label {\n      font-size: 0.75rem; \n    }\n    .form-item-input-supplier {\n      width: 100%;\n    }\n    .form-item-button-supplier {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        margin: auto;\n\n    }\n    .form-item-button-supplier button:first-child {\n        margin-bottom: 1rem;\n        margin-right: 0;\n\n    }\n  }\n\n  @media (max-width: 320px) {\n    .styled-table-container .ant-table-wrapper .ant-table-pagination {\n      display: flex;\n      flex-wrap: wrap;\n      row-gap: 8px;\n    }\n  }\n\n  @media (max-width: 576px) {\n    .error-message {\n      font-size: 10px; \n      margin-top: 2px; \n    }\n  }\n\n  .styled-table {\n    width: 100%;\n    table-layout: fixed; \n    white-space: nowrap; \n    overflow-x: auto; \n  }\n  \n  .styled-table .ant-table-tbody .ant-table-cell {\n    width: auto; \n    max-width: 200px; \n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .styled-table .ant-table-content {\n    min-width: 100%;\n    width: auto;\n  }\n\n  .styled-table-container .ant-table-wrapper .ant-table-pagination {\n    justify-content:  center;\n    margin-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
